const consildatedCashFlow = {
  consolidated_cash_flow: `Consolidated View`,
  filters: "Filters",
  bank_account: "Bank Account",
  reset: "Reset",
  apply: "Apply",
  total_credit: "Total Credit",
  total_debit: "Total Debit",
  cash_flow_overview: "Cash Flow Overview",
  cash_balance_beginning_month: "Cash Balance at Beginning of the Month",
  cash_inflow: "Cash Inflow",
  cash_outflow: "Cash Outflow",
  cash_balance_end_month: "Cash Balance at End of Month",
  bankaccount_currency_should_same: "Please select banks of same currency",
  select_banks: "Select Banks",
};

export default consildatedCashFlow;
